/**
 * Created by Jerker Nord on 2020-06-11.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {LoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/event/LoaderEvent";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {BitmapTextStyleData, MonkeysGoldBitmapText} from "./MonkeysGoldBitmapText";

export class MonkeysGoldColossalMultiplierTextController {

    private _2x2BitmapTexts:MonkeysGoldBitmapText[];
    private _2x2BitmapStyle:BitmapTextStyleData = {
        fontName : "NumbersWinCountUp",
        fontSize : 30
    };
    private _3x3BitmapTexts:MonkeysGoldBitmapText[];
    private _3x3BitmapStyle:BitmapTextStyleData = {
        fontName : "NumbersWinCountUp",
        fontSize : 30
    };

    constructor() {
        EventHandler.addEventListener(this, LoaderEvent.RESOURCES_LOADED, (event:LoaderEvent) => this.onResourcesLoaded(event));
    }

    private onResourcesLoaded(event:LoaderEvent):void {
        if(event.key != ResourcesGroupName.MAIN) {
            return;
        }
        this._2x2BitmapTexts = [];
        let tempText:MonkeysGoldBitmapText;
        for(let i:number = 0; i < 18; i++) {
            tempText = new MonkeysGoldBitmapText("", this._2x2BitmapStyle);
            tempText.anchor = new PIXI.Point(0.70, 0.50);
            tempText.visible = false;
            tempText.inUse = false;
            this._2x2BitmapTexts.push(tempText);
        }
        this._3x3BitmapTexts = [];
        for(let i:number = 0; i < 8; i++) {
            tempText = new MonkeysGoldBitmapText("", this._3x3BitmapStyle);
            tempText.anchor = new PIXI.Point(0.80, 0.76);
            tempText.visible = false;
            tempText.inUse = false;
            this._3x3BitmapTexts.push(tempText);
        }
    }

    // @ts-ignore
    public get2x2MultiplierText():MonkeysGoldBitmapText {
        for(let i:number = 0; i < this._2x2BitmapTexts.length; i++) {
            if(this._2x2BitmapTexts[i].inUse == false) {
                this._2x2BitmapTexts[i].inUse = true;
                return this._2x2BitmapTexts[i];
            }
        }
    }

    // @ts-ignore
    public get3x3MultiplierText():MonkeysGoldBitmapText {
        for(let i:number = 0; i < this._3x3BitmapTexts.length; i++) {
            if(this._3x3BitmapTexts[i].inUse == false) {
                this._3x3BitmapTexts[i].inUse = true;
                return this._3x3BitmapTexts[i];
            }
        }
    }
}